import { useQueries } from '@tanstack/react-query';

import type { Product } from '@nucleus-commerce/api-client/admin';

import { productQueryOptions } from '@/features/products';

export interface PostProductRow {
  productId: string;
  product: Product | undefined;
  isPending: boolean;
  error: unknown;
}

/** The master products a post is about, by id, for their titles and the prefill text. */
export function usePostProducts(productIds: readonly string[]): PostProductRow[] {
  return useQueries({
    queries: productIds.map((productId) => ({
      ...productQueryOptions(productId),
      staleTime: 60_000,
    })),
    combine: (results) =>
      results.map((result, index) => ({
        productId: productIds[index] ?? '',
        product: result.data,
        isPending: result.isPending,
        error: result.error,
      })),
  });
}
